import { AdminComponent } from '~/components/admin-component/admin-component';

export const Pronouns = () => (
  <AdminComponent
    componentName="Pronouns"
    title="Pronouns"
  />
);
